import { useQuery } from "@tanstack/react-query";
import { useAuth } from "#/hooks/use-auth";
import { queryKeys } from "#/hooks/query-keys";
import { fetchMyReferralStats } from "#/lib/api/referrals";

export function useMyReferralStats() {
	const { isAuthenticated, userId } = useAuth();

	return useQuery({
		queryKey: queryKeys.referrals.myStats(userId),
		queryFn: fetchMyReferralStats,
		enabled: isAuthenticated,
		staleTime: 30_000,
	});
}
